
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkMontageplanBlockOrientationTypeEnum } from '../models/work-montageplan-block-orientation-type-enum';

export function getUpdateMontageplanBlockDatesDtoFormGroup() {
return new FormGroup({
    id: new FormControl<number | undefined>(undefined, [Validators.required]),
    blockType: new FormControl<WorkMontageplanBlockOrientationTypeEnum | undefined>(undefined, [Validators.required]),
    teamId: new FormControl<number | undefined>(undefined, [Validators.required]),
    installationStart: new FormControl<string | undefined>('', [Validators.required]),
    installationEnd: new FormControl<string | undefined>('', [Validators.required]),
    comment: new FormControl<string | undefined>(''),
    expectedVersion: new FormControl<number | undefined>(undefined, [Validators.required, Validators.min(1)]),
})
;
}
      